import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './testimonial17.css'

const Testimonial17 = (props) => {
  return (
    <div className={`thq-section-padding ${props.rootClassName} `}>
      <div className="testimonial17-max-width thq-section-max-width">
        <div className="testimonial17-container1">
          <h2 className="testimonial17-text10 thq-heading-2">
            {props.heading1 ?? (
              <Fragment>
                <span className="testimonial17-text23">Our Clients</span>
              </Fragment>
            )}
          </h2>
          <span className="testimonial17-text11 thq-body-small">
            {props.content1 ?? (
              <Fragment>
                <span className="testimonial17-text22">
                  We work with some of the largest service providers locally,
                  subject matter experts, and other established organisations to
                  ensure our training programs are relevant, of the highest
                  quality, provide valuable knowledge and are delivered by
                  seasoned educators
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div className="thq-grid-2 testimonial17-container2">
          <div className="thq-animated-card-bg-2 testimonial17-accent2-bg1">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="testimonial17-card1 thq-card"
              >
                <div className="testimonial17-container3">
                  <img
                    alt={props.imageAlt}
                    src={props.imageSrc}
                    className="testimonial17-image1"
                  />
                  <div className="testimonial17-container4">
                    <span className="testimonial17-text12 thq-body-small">
                      {props.author1Position ?? (
                        <Fragment>
                          <span className="testimonial17-text21">
                            Optimi Workplace
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text13 thq-body-small">
                  {props.review1 ?? (
                    <Fragment>
                      <span className="testimonial17-text24">
                        Optimi Workplace is a proud member of the Optimi Group.
                        Accessible learning solutions for corporate and public
                        sector training.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="testimonial17-card2 thq-card"
              >
                <div className="testimonial17-container5">
                  <img
                    alt={props.imageAlt2}
                    src={props.imageSrc2}
                    className="testimonial17-image2"
                  />
                  <div className="testimonial17-container6">
                    <span className="testimonial17-text14 thq-body-small">
                      {props.author2Position ?? (
                        <Fragment>
                          <span className="testimonial17-text25">
                            Department of Tourism
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text15 thq-body-small">
                  {props.review2 ?? (
                    <Fragment>
                      <span className="testimonial17-text18">
                        Leading sustainable tourism development for inclusive
                        economic growth in South Africa.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="testimonial17-container7">
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="testimonial17-card3 thq-card"
              >
                <div className="testimonial17-container8">
                  <img
                    alt={props.imageAlt1}
                    src={props.imageSrc1}
                    className="testimonial17-image3"
                  />
                  <div className="testimonial17-container9">
                    <span className="testimonial17-text16 thq-body-small">
                      {props.author3Position ?? (
                        <Fragment>
                          <span className="testimonial17-text19">Transnet</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text17 thq-body-small">
                  {props.review3 ?? (
                    <Fragment>
                      <span className="testimonial17-text20">
                        ​​​​​​​​​​​​​​​​​​​​Transnet is the largest and most
                        crucial part of the freight logistics chain that
                        delivers goods to each and every South African.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonial17.defaultProps = {
  imageAlt1: 'image',
  imageSrc2: '/tourlogo-200h.png',
  imageAlt: 'image',
  review2: undefined,
  author3Position: undefined,
  review3: undefined,
  imageSrc1: '/logo1-200h.png',
  rootClassName: '',
  author1Position: undefined,
  imageSrc: '/optimi-workplace-logo-480x816-200w.png',
  content1: undefined,
  heading1: undefined,
  imageAlt2: 'image',
  review1: undefined,
  author2Position: undefined,
}

Testimonial17.propTypes = {
  imageAlt1: PropTypes.string,
  imageSrc2: PropTypes.string,
  imageAlt: PropTypes.string,
  review2: PropTypes.element,
  author3Position: PropTypes.element,
  review3: PropTypes.element,
  imageSrc1: PropTypes.string,
  rootClassName: PropTypes.string,
  author1Position: PropTypes.element,
  imageSrc: PropTypes.string,
  content1: PropTypes.element,
  heading1: PropTypes.element,
  imageAlt2: PropTypes.string,
  review1: PropTypes.element,
  author2Position: PropTypes.element,
}

export default Testimonial17
